import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Card } from './Card.interface';

@Component({
    selector: 'app-tco',
    templateUrl: './tco.component.html',
    styleUrls: ['./tco.component.scss'],
    standalone: false
})
export class TCOComponent {
  KTL: Card[] = [
    {
      id: 'ktl-card',
      class: 'KTL',
      imgSrc: './assets/KTL.png',
      footerText: 'KTL',
      navigateTo: '',
      cursor: 'not-allowed',
      backgroundColor: '#fffde7',
      width: '',
      height: '',
      borderColor: '#FFEA25',
      children: [
        {
          id: 'ktl-flare-card',
          class: 'FlareKTL',
          imgSrc: './assets/Flare​.png',
          footerText: 'KTL Flare​ Dashboard​',
          navigateTo: '/TCO/ProcessEng/FD/KTL/Input/ProcessEngineer/Flaring',
          cursor: 'pointer',
          backgroundColor: '#ffefe1',
          width: '50%',
          height: '110%',
          borderColor: '#FFAF6D',
          children: [],
        },
        {
          id: 'ktl-fuel-card',
          class: 'FuelKTL',
          imgSrc: './assets/FuelGas​.png',
          footerText: 'KTL​ Fuel Gas​ Dashboard​',
          navigateTo: '/TCO/ProcessEng/FGD/KTL/ProductionGasBalance',
          cursor: 'pointer',
          backgroundColor: '#e3f2fd',
          width: '55%',
          height: '110%',
          borderColor: '#3FADFF',
          children: [],
        },
        {
          id: 'so2-card',
          class: 'SO2',
          imgSrc: './assets/SO2Emissions.png',
          footerText: 'KTL U500 SO2 Emissions​ Dashboard​',
          navigateTo: '/TCO/ProcessEng/FD/KTLSGP/So2Emissions/MonthlyReport',
          cursor: 'pointer',
          backgroundColor: '#fff59d',
          width: '30%',
          height: '30%',
          borderColor: '#DEC900',
          children: [],
        },
      ],
    },
  ];

  SGP: Card[] = [
    {
      id: 'sgp-card',
      class: 'SGP',
      imgSrc: './assets/KTL.png',
      footerText: 'SGP',
      navigateTo: '',
      cursor: 'not-allowed',
      backgroundColor: '#fffde7',
      width: '',
      height: '',
      borderColor: '#FFEA25',
      children: [
        {
          id: 'sgp-flare-card',
          class: 'FlareSGP',
          imgSrc: './assets/Flare​.png',
          footerText: 'SGP Flare​ Dashboard​',
          navigateTo: '/TCO/ProcessEng/FD/SGP/Input/ProcessEngineer/Flaring',
          cursor: 'pointer',
          backgroundColor: '#ffefe1',
          width: '50%',
          height: '110%',
          borderColor: '#FFAF6D',
          children: [],
        },
        {
          id: 'sgp-fuel-card',
          class: 'FuelSGP',
          imgSrc: './assets/FuelGas​.png',
          footerText: 'SGP Fuel Gas​ Dashboard​',
          navigateTo: 'TCO/ProcessEng/FGD/SGP',
          cursor: 'pointer',
          backgroundColor: '#e3f2fd',
          width: '55%',
          height: '130%',
          borderColor: '#3FADFF',
          children: [],
        },
        {
          id: 'so2-card',
          class: 'SO2',
          imgSrc: './assets/SO2Emissions.png',
          footerText: 'SGP U500 SO2 Emissions​ Dashboard​',
          navigateTo: '/TCO/ProcessEng/FD/KTLSGP/So2Emissions/MonthlyReport',
          cursor: 'pointer',
          backgroundColor: '#fff59d',
          width: '30%',
          height: '30%',
          borderColor: '#DEC900',
          children: [],
        },
      ],
    },
  ];

  ThreeGP: Card[] = [
    {
      id: '3gp-card',
      class: 'ThreeGP',
      imgSrc: './assets/KTL.png',
      footerText: '3GP & 3GI',
      navigateTo: '',
      cursor: 'not-allowed',
      backgroundColor: '#fffde7',
      width: '',
      height: '',
      borderColor: '#FFEA25',
      children: [
        {
          id: '3gp-flare-card',
          class: 'Flare3GP',
          imgSrc: './assets/Flare​.png',
          footerText: '3GP Flare​ Dashboard​',
          navigateTo:
            '/TCO/ProcessEng/FD/3GP/Input/ProcessEngineer/ManualFlaring',
          cursor: 'pointer',
          backgroundColor: '#ffefe1',
          width: '50%',
          height: '110%',
          borderColor: '#FFAF6D',
          children: [],
        },
        {
          id: '3gp-fuel-card',
          class: 'Fuel3GP',
          imgSrc: './assets/FuelGas​.png',
          footerText: '3GP Fuel Gas​ Dashboard​',
          navigateTo: 'TCO/ProcessEng/FGD/3GP/GUR',
          cursor: 'pointer',
          backgroundColor: '#e3f2fd',
          width: '55%',
          height: '120%',
          borderColor: '#3FADFF',
          children: [],
        },
        {
          id: '3gi-fuel-flare-card',
          class: 'Flare3GI',
          imgSrc: './assets/SGI.png',
          footerText: '3GI Flare & Fuel Gas​ Dashboard​',
          navigateTo: '',
          cursor: 'not-allowed',
          backgroundColor: '#ede7f6',
          width: '50%',
          height: '110%',
          borderColor: '#B989FF',
          children: [],
        },
      ],
    },
  ];

  FieldAndLPG: Card[] = [
    {
      id: 'field-lpg-card',
      class: 'FieldAndLPG',
      imgSrc: './assets/KTL.png',
      footerText: 'Field & LPG Park     ',
      navigateTo: '',
      cursor: 'not-allowed',
      backgroundColor: '#fffde7',
      width: '',
      height: '',
      borderColor: '#FFEA25',
      children: [
        {
          id: 'field-lpg-flare-card',
          class: 'FlareFuelField',
          imgSrc: './assets/Flare&FuelGas.png',
          footerText: 'Field​ Flare & Fuel Gas ​Dashboard',
          navigateTo: '/TCO/ProcessEng/FD/FIELD/FieldCalc/DryGas',
          cursor: 'pointer',
          backgroundColor: '#ede7f6',
          width: '55%',
          height: '130%',
          borderColor: '#B989FF',
          children: [],
        },
        {
          id: 'field-lpg-fuel-card',
          class: 'FlareFuelLPG',
          imgSrc: './assets/FlareFuelLPG.png',
          footerText: 'LPG​ Flare & Fuel Gas Dashboard',
          navigateTo: '/TCO/ProcessEng/FD/LPG/Input/TargetPermit',
          cursor: 'pointer',
          backgroundColor: '#ede7f6',
          width: '50%',
          height: '100%',
          borderColor: '#B989FF',
          children: [],
        },
      ],
    },
  ];

  IUSandSGI: Card[] = [
    {
      id: 'ius-sgi-card',
      class: 'IUSandSGI',
      imgSrc: './assets/KTL.png',
      footerText: 'Internal Usage & SGI',
      navigateTo: '',
      cursor: 'not-allowed',
      backgroundColor: '#fffde7',
      width: '',
      height: '',
      borderColor: '#FFEA25',
      children: [
        {
          id: 'fuel-gas-ius-card',
          class: 'FuelGasInternalUsage',
          imgSrc: './assets/FuelGasIU.png',
          footerText: 'TCO Internal Usage​ & Sales Gas Fuel Gas Dashboard',
          navigateTo: '/TCO/ProcessEng/FGD/IUS/Input/boilers-motohours-data',
          cursor: 'pointer',
          backgroundColor: '#e3f2fd',
          width: '55%',
          height: '130%',
          borderColor: '#3FADFF',
          children: [],
        },
        {
          id: 'sgi-card',
          class: 'SGI',
          imgSrc: './assets/SGI.png',
          footerText: 'SGI Flare & Fuel Gas Dashboard​',
          navigateTo: '/TCO/ProcessEng/FD/SGI/flare-report',
          cursor: 'pointer',
          backgroundColor: '#ede7f6',
          width: '50%',
          height: '100%',
          borderColor: '#B989FF',
          children: [],
        },
      ],
    },
  ];

  constructor(private router: Router) {}

  navigateTo(route: string): void {
    if (route) {
      this.router.navigate([route]);
    }
  }
}
